module.exports = __webpack_public_path__ + "img/tyreExample.de60e820.png";